module.exports = __webpack_public_path__ + "assets/images/airports-sg/tablet.svg?v=a70dacd2";